<style lang="scss" scoped>
.dropdown {
  color:#fff;
  font-size: 1.5rem;
  font-weight: bold;
  position: absolute;
  top: -3px;
  left: 10px;
  z-index: 2;

  &.open {
    background-color: #000;
    height: 100%;
    width: 44%;
    @media screen and (max-width: 768px) {
      height: 68%;
      width: 100%;
    }  
  }

  .toggle-categories {
    cursor: pointer;
    user-select: none;
    margin-right: 30px;
  }
  .category-tags {
    width: 96%;
    .tag {
      @media screen and (min-width: 768px) {
        font-size: 1rem;
      }
      // @media screen and (max-width: 768px) {
      //   font-size: 0.85rem;
      // } 
    }
  }
  .tag {
    cursor: pointer;
    margin: 3px 0;
      background: #000;
      color: #fff;
    &:hover {
      background: #fff;
      color: #000;
    }
  }
  .search {
    i {
      font-size: 1.2rem; 
      left: 25px;
      position: absolute;
      top: 9.5px;
    }
    input {
      color: #fff;
      @media screen and (max-width: 768px) {
        max-width: 60%;
      }
    }
  }
}
.shopping {
  font-size: 1.5rem;
  position: absolute;
  top: 4px;
  left: 43%;
  z-index: 2;
  cursor: pointer;
  user-select: none;
  a {
    color:#fff !important;
  }

  @media screen and (max-width: 768px) {
    left: 93% !important;
  }
}

.share {
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 4px;
  left: 10px;
  z-index: 2;
  i {
    font-size: 1.2rem;
  }
  span {
    color: #fff;
    font-size: .8rem;
    transition: all ease-in-out .6s;
  }
  @media screen and (max-width: 768px) {
      max-height: 100px;
      position: absolute;
      top: 35.5%;
    // display: none;
    // bottom: 28.7%;
    &.full {
      top: 61%;
    }
  }
}

.share-hide {
  @media screen and (max-width: 768px) {
    display: none;
  }
}

.zen {
  font-size: 1.3rem;
  position: absolute;
  bottom: 0px;
  left: 22%;
  z-index: 2;
  cursor: pointer;
  user-select: none;
  p {
    color:#fff;
    font-weight: 500;

    &:hover {
      opacity: 1 !important;
    }
  }
  @media screen and (max-width: 768px) {
    display: none;
    // bottom: 28%;
    // left: 48.5% !important;
    // &.full {
    //   bottom: 0px;
    // }
  }
}

.menu {
  color:#fff;
  font-size: 1.5rem;
  position: absolute;
  bottom: -4px;
  left: 43%;
  z-index: 2;
  cursor: pointer;
  user-select: none;

  @media screen and (max-width: 768px) {
    display: none;
    // bottom: 27.5%;
    // left: 93% !important;
    //  &.full {
    //    bottom: -4px;
    //  }
  }
}
.image-wrapper {
  height: 100%;
  @media screen and (max-width: 768px) {
    height: 74%;
    &.full {
      height: 100%
    }
  }
}
.images {
  background-color: #000;
  position: relative;

  .tag {
    cursor: pointer;
    background-color: #fff;
    font-weight: bold;
    margin-top: 50px;
  }
}
.scroll-column {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
.years {
  background-color: #999;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 768px) {
    align-items: center;
    overflow-x: scroll;
    flex-direction: row;
  }
  
  // div {
  //    @media screen and (max-width: 768px) {
  //      flex-direction: row;
  //      flex-wrap: nowrap;
  //      height: 100%;
  //      justify-content: space-evenly;
  //      margin-top: 0;
  //      overflow-x: auto;
  //    } 
  // }
  a {
    color: #000 !important;
    font-weight: bold;
    text-decoration: none;
    margin: 3px;
    font-size: 1.1em;

    &.active {
      color: #fff !important;
    }

    &:hover {
      color: #e0dddd !important;
    }
    @media screen and (max-width: 768px) {
      margin: 0 5px;
    }
  }
  @media screen and (max-width: 768px) {
    height: 7%;
  }
}
.text-area {
  background-color: #fff;
  padding: 50px;
  @media screen and (max-width: 768px) {
    padding: 10px;
    height: 29%;
  }
}
.white-action {
  color: #fff;
  cursor: pointer;
}
.white-text {
  color: #fff;
}
.active-description {
  color: #cccccc;
  font-size: 14px;
}
.icon {
  color: #fff;
  cursor: pointer;
  font-size: 28px;
}
.contact-link {
  line-height: 1em;
  position: absolute;
  top: 10px;
  right: 15px;

  &.full {
    display: none;
  }

  a {
    font-size: 1.3em;
    i {
      color: #957513;
    }
     &:first-child {
       i {
        font-size: 1.2em;
        margin-right: 15px;
       }
     }
  }
  @media screen and (max-width: 768px) {
    display: none;
    // justify-content: space-around;
    // top: 67.5% !important;
    // right: 7%;
    // left: 7%;
    // &.full {
    //   display: flex;
    //   top: 95.1% !important;
    // }
    // z-index: 2;    
    // a {
    //   i {
    //     color: #fff;
    //     font-size: 1.29rem;
    //   }
    //   &:first-child {
    //     i {
    //       font-size: 1.1em;
    //       padding-bottom: 1px;
    //     }
    //   }
    // }
  }
}
.top-action-text {
  position: fixed;
  top: 9px;
  margin: auto;
  z-index: 5;
  i {
    font-size: 1.5em;
  }
}
.mobile-icons {
  display: none;
  @media screen and (max-width: 768px) {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    position: absolute;
    bottom: 1%;
    width: 100%;

    i {
      color: #fff;
      font-size: 20px;
    }
    p {
      font-size: 20px;
      font-weight: 500; 
    }
    .ion-md-share {
      font-size: 19px;
    }
    // .ion-md-globe {
    //   font-size: 1.3em;
    // }
    // .ion-md-mail {
    //   font-size: 1.25em;
    // }
    .ion-md-menu {
      font-size: 22px;
    }
    &.has-zen {
      i {
        visibility: hidden;
      }
    }
  } 
}
</style>

<template>
  <div class="home height-100">
    <div
      v-if="loading"
      class="frow centered width-100 height-100"
    >
      <Loader />
    </div>
    <div
      v-else
      class="height-100"
    >
      <div
        class="dropdown frow"
        :class="{
          open: showTags, 
          'column-start': showTags, 
          'row-start items-center': !showTags
        }"
      >
        <div 
          v-if="!zen"
          class="toggle-categories"
          @click="showTags = !showTags"
        >
          ...
        </div>
        <div
          v-if="!showTags"
          class="search"
        >
          <i
            class="icon ion-md-search"
            @click="toggleSearch()"
          />
          <input
            v-if="showSearch"
            v-model="search"
            placeholder="Search for Art"
          >
        </div>
        <div
          v-if="showTags"
          class="frow category-tags"
        >
          <span
            v-for="(tag, index) in tags"
            :key="`${index}-${tag}`"
            class="tag"
            @click="filterArtByTag(tag)"
          >
            {{ tag }}
          </span>
        </div>
      </div>
      <div 
        v-if="!zen"
        class="shopping"
        :style="{left: sidebarOpen ? '43%': '98%',}"
      >
        <a :href="purchase">
          <i 
            class="ion ion-md-cart" 
            :style="{color: activeArt ? '#ffc000' : '#fff'}"
          />
        </a>
      </div>
      <div
        v-if="!zen"
        :class="{'full': !sidebarOpen}"
        class="contact-link frow space-between"
      >
        <a
          href="http://rozdimon.com"
          target="_blank"
        >
          <i
            class="icon ion-md-globe"
          />
        </a>
        <a href="mailto:roz@artstory.net">
          <i
            class="icon white ion-md-mail"
            @click="$emit('changeArt', 'next')"
          />
        </a>
      </div>
      <div
        class="frow image-wrapper"
        :class="{'full': !sidebarOpen}"
      >
        <div
          :style="{'overflow': activeArt ? 'hidden': 'scroll'}" 
          class="col-md-5-11 images scroll-column"
        >
          <div class="frow row-center">
            <span
              v-if="!zen && ((activeYear || activeTag) && !activeArt)"
              class="white-action top-action-text"
              @click="clearFilters"
            >
              <i
                class="ion ion-md-grid"
              />
            </span>
            <span
              v-else-if="!activeArt"
              class="white-action top-action-text"
              @click="clearFilters"
            >
              <!-- @click="setActiveArt(previousImage)" -->
              <i
                class="ion ion-md-grid"
              />
            </span>
            <span
              v-if="!zen && previousImage && !activeArt && !activeYear && !activeTag"
              class="white-action top-action-text"
              @click="setActiveArt(previousImage)"
            >
              <!-- <i
                class="ion ion-md-square-outline"
              /> -->
            </span>
            <span
              v-if="activeTag"
              class="tag"
              @click="showTags = !showTags"
            > {{ activeTag }}</span>
          </div>
          <br>
          <ActiveArt
            v-if="activeArt"
            :active-art="activeArt"
            :settings="settings"
            :active-category="activeTag"
            :side-bar-open="sidebarOpen"
            @changeArt="changeArt"
            @close="viewAllImages"
            @tagClicked="filterArtByTag"
          />
          <ImageBank 
            v-else
            :art="filteredArt"
            :settings="settings"
            :active-category="activeTag"
            :search="search"
            @setActiveArt="setActiveArt"
          />
          <div
            class="mobile-icons"
            :class="{'has-zen': zen}"
          >
            <i
              class="icon ion-md-share"
              @click="copyLink()"
            />

            <a
              href="http://rozdimon.com"
              target="_blank"
            >
              <i
                class="icon ion-md-globe"
              />
            </a>

            <p
              :style="{
                color: zen ? '#999' : '#fff',
                opacity: zen ? '0.5' : '1', 
              }"
              @click="setZen(!zen)"
            >
              Z
            </p>

            <a
              href="mailto:roz@artstory.net"
            >
              <i
                class="icon ion-md-mail"
                @click="$emit('changeArt', 'next')"
              />
            </a>

            <i
              class="ion ion-md-menu"
              @click="setSidebar(!sidebarOpen)"
            />
          </div>
        </div>
        <div
          v-if="sidebarOpen"
          class="col-md-1-11 years scroll-column"
        >
          <a
            v-if="hasIntroStory"
            href="/story/intro"
            @click="showIntro"
          >INTRO</a>
          <a
            v-for="year in years"
            :key="year"
            :class="{'active': activeYear == year}"
            :href="`/year/${year}`"
            @click.prevent="toggleActiveYear(year)"
          >
            {{ year }}
          </a>
        </div>
        <div
          v-if="sidebarOpen"
          class="col-md-5-11 text-area scroll-column"
        >
          <Stories
            :active-art="activeArt"
            :active-story="activeStory"
            :active-year="activeYear"
            :stories="filteredStories"
            :unfiltered-stories="stories"
            @setActiveStory="changeStoryAndClearArt"
          />
        </div>
      </div>
      <div
        v-if="!zen"
        :class="{'full': !sidebarOpen}"
        class="share"
      >
        <Share
          v-if="showShare"
          :share-data="shareData"
        />
        <i
          class="icon white ion-md-share share-hide"
          @click="copyLink()"
        />
      </div>
      <div 
        :style="{left: sidebarOpen ? '22.3%': '50%'}"
        :class="{'full': !sidebarOpen}"
        class="zen"
        @click="setZen(!zen)"
      >
        <p
          :style="{
            color: zen ? '#999' : '#fff',
            opacity: zen ? '0.5' : '1', }"
        >
          Z
        </p>
      </div>
      <div 
        v-if="!zen"
        class="menu"
        :class="{'full': !sidebarOpen}"
        :style="{left: sidebarOpen ? '43%': '98%'}"
        @click="setSidebar(!sidebarOpen)"
      >
        <i class="ion ion-md-menu" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Loader from '@/components/Loader.vue';
import ImageBank from '@/components/Home/ImageBank.vue';
import ActiveArt from '@/components/Home/ActiveArt.vue';
import Stories from '@/components/Home/Stories.vue';
import Share from '@/components/Share';

export default {
  name: 'Home',
  components: {
    Loader,
    ImageBank,
    ActiveArt,
    Stories,
    Share,
  },
  data() {
    return {
      activeStory: null,
      stories: [],
      loading: true,
      years: [],
      artWork: [],
      activeArt: null,
      settings: null,
      activeYear: null,
      activeTag: null,
      showTags: false,
      tags: null,
      previousImage: null,
      showShare: false,
      shareData: {},
      showSearch: false,
      search: null,
    };
  },
  computed: {
    ...mapState({
      zen: (state) => state.zen,
      sidebarOpen: (state) => state.sidebarOpen,
    }),
    API() {
      return this.$API;
    },
    hasIntroStory() {
      return this.stories.find((s) => s.isIntroStory);
    },
    purchase() {
      // eslint-disable-next-line max-len
      if (this.activeArt) {
        return `mailto:roz@artstory.net?subject=Art Purchase&body=I am interested in purchasing ${this.activeArt.title}. Please advise.`;
      }
      return 'mailto:roz@artstory.net?subject=Art Purchase&body=I am interested in purchasing some art. Please advise.';
    },
    storiesStub() {
      let stub = [];
      let i = 0;
      while (i < 10) {
        stub = stub.concat(this.stories);
        i += 1;
      }
      return stub;
    },
    filteredStories() {
      let stories = this.stories.filter((s) => !s.isIntroStory);
      if(this.activeYear) {
        return this.filterByYear(stories);
      }
      return stories;
    }, 
    filteredArt() {
      let artWork = this.artWork.filter((a) => !a.hidden);
      if (this.showSearch && this.search) {
        artWork = this.filterBySearchTerm(this.search);
      }
      if (this.activeTag) {
        return this.filterByTag(artWork);
      }
      if(this.activeYear) {
        return this.filterByYear(artWork);
      }
      return artWork;
    },
  },
  created() {
    this.getSettings();
    this.getArt();
    this.getStories();
    window.addEventListener('hashchange', this.handleHashChange, false);
  },
  mounted() {
    window.addEventListener('keydown', this.keyDown);
  },
  methods: {
    ...mapMutations([
      'setZen',
      'setSidebar',
    ]),
    keyDown(e) {
      if (this.activeArt) {
        if (e.keyCode == 39) {
          this.changeArt('next');
        }
        else if (e.keyCode == 37) {
          this.changeArt('previous');
        }
      }
    },
    changeArt(direction) {
      this.activeStory = null;
      const activeArtIndex = this.filteredArt.indexOf(this.activeArt);
      let nextArtIndex = direction == 'next' ? activeArtIndex + 1 : activeArtIndex - 1;
      if (direction === 'next') {
        if (activeArtIndex === this.filteredArt.length - 1) {
          // this.setActiveArt(null);
          this.setActiveArt(this.filteredArt[0]); 
        }
        if (!this.activeTag && !this.search) {
          nextArtIndex = this.checkArtForCategoryOnly(activeArtIndex + 1, direction);
        }
        this.setActiveArt(this.filteredArt[nextArtIndex]);
      }
      if (direction === 'previous') {
        if (activeArtIndex === 0) {
          // this.setActiveArt(null);
          this.setActiveArt(this.filteredArt[this.filteredArt.length - 1]);
        }
        if (!this.activeTag) {
          nextArtIndex = this.checkArtForCategoryOnly(activeArtIndex - 1, direction);
        }
        this.setActiveArt(this.filteredArt[nextArtIndex]);
      }
      this.setLink();
    },
    checkArtForCategoryOnly(index, direction) {
      if (this.filteredArt[index].categoryOnly) {
        while(this.filteredArt[index].categoryOnly) {
          direction == 'next' ? index += 1 : index -= 1;
        } 
      }
      return index;
    },
    clearFilters() {
      // if (!this.activeArt) {
      this.search = null;
      this.showSearch = null;
      // }
      this.activeArt = null;
      this.activeStory = null;
      this.$router.push('/');
      this.showTags = false;
      this.activeTag = null;
      this.activeYear = null;
    },
    copyLink() {
      let title = '';
      let description = '';
      let hashtags;
      if (this.activeArt) {
        title += `${this.activeArt.title} `;
        description += `
            check out this art ${this.activeArt.title}.
            ${this.activeArt.description}
          `;
        hashtags = this.activeArt.tags ? this.activeArt.tags.toString() : null;
      }
      if (this.activeArt && this.activeStory) {
        description += ' & ';
      }
      if (this.activeStory) {
        title += this.activeArt.title;
        description += `
            check out this story ${this.activeStory.title}.
            ${this.activeStory.description}
          `;
      }
      if (!this.activeArt && !this.activeStory) {
        title = 'check out ArtStory by Roz Dimon';
        description = 'ArtStory - art stories \'American style\' from Ketchup to Wall Street; Guns to Jesus ; a custom-coded digital blog and memoir by artist Roz Dimon';
      }
      this.shareData = {
        url: window.location.href,
        title: title.replace(/<\/?[^>]+(>|$)/g, ''),
        description: description.replace(/<\/?[^>]+(>|$)/g, ''),
        quote: description.replace(/<\/?[^>]+(>|$)/g, ''),
        // hashtags: hashtags,
        twitterUser: 'rozdimon',
      };
      this.showShare = !this.showShare;
      // setTimeout(() => {
      //   this.showShare = false;
      // }, 20000);
      // }
    },
    filterArtByTag(tag) {
      this.clearFilters();
      this.$router.push(`/category/${tag}`);
      this.activeArt = null;
      this.activeTag = tag;
      this.showTags = false;
    },
    filterBySearchTerm(search) {
      return this.artWork.filter((art) => {
        if (art.title && art.description) {
          return art.title.toLowerCase().includes(search.toLowerCase()) 
        || art.description.toLowerCase().includes(search.toLowerCase());
        }
        return false;
      });
    },
    filterByTag(items) {
      return items.filter((item) => {
        if (item.tags) {
          return item.tags.includes(this.activeTag);
        }
        return false;
      });
    },
    filterByYear(items) {
      return items.filter((item) => {
        return new Date(item.date).getFullYear() == this.activeYear;
      });
    },
    getStories() {
      this.axios.get(`${this.$API}/stories?_sort=date:DESC&_limit=-1`).then((response) => {
        this.stories = response.data.filter((s) => s.draft != true);
        this.updateYears(this.stories);
        this.readInLink();
      });
    },
    getSettings() {
      this.axios.get(`${this.$API}/settings`).then((response) => {
        this.settings = response.data[0];
        this.tags = this.settings.categories;
      });
    },
    getArt() {
      this.axios.get(`${this.$API}/arts?_sort=date:DESC&_limit=-1`).then((response) => {
        this.artWork = [];
        response.data.forEach((art) => {
          if (art.image) {
            art.imageUrl = art.image.url;
            if (process.env.NODE_ENV === 'development') {
              // art.imageUrl = `${this.$API}/${art.image.url}`;
            }
          }
          this.artWork.push(art);
        });
        this.updateYears(this.artWork);
        this.readInLink();
        this.loading = false;
      });
    },
    handleHashChange() {
      this.showTags = false;
      const type = window.location.hash.substring(1).split('-')[0];
      const id = window.location.hash.substring(1).split('-')[1];
      if (type == 'art') {
        const art = this.artWork.find((a) => a.id == id);
        if (art) {
          this.activeArt = art;
          this.setLink();
        }
      } else if (type == 'story') {
        const story = this.stories.find((s) => s.id == id);
        if (story) {
          this.activeStory = story;
          this.setLink();
        }
      }
    },
    readInLink() {
      if (this.$route.params.artLink) {
        this.activeArt = this.artWork.find((a) => a.link == this.$route.params.artLink);
      }
      if (this.$route.params.storyLink) {
        console.log('reading in story link');
        this.activeStory = this.stories.find((s) => s.link == this.$route.params.storyLink);
      } else {
        this.showIntro();
      }
      if (this.$route.params.categoryName) {
        this.activeTag = this.$route.params.categoryName;
      }
      if (this.$route.params.year) {
        this.activeYear = this.$route.params.year;
      }
    },
    removeHash () { 
      history.pushState('', document.title, window.location.pathname + window.location.search);
    },
    setActiveArt(art) {
      this.showTags = false;
      this.previousImage = this.activeArt;
      this.activeArt = art;
      if ((this.activeArt && this.activeArt.stories.length > 0) && !this.activeArt.stories[0].draft) {
        this.setActiveStory(this.activeArt.stories[0]);
      } else {
        // this.setActiveStory(null);
      }
      this.setLink();
    },
    changeStoryAndClearArt(story) {
      this.activeArt = null;
      this.setActiveStory(story);
    },
    setActiveStory(story) {
      this.activeStory = story;
      this.setLink();
    },
    setLink() {
      let link = '';
      if (this.activeArt) {
        link += `/art/${this.activeArt.link}`;
      }
      if (this.activeStory) {
        link += `/story/${this.activeStory.link}`;
      }
      console.log(`Pushing to ${link}`);
      this.$router.push(link);
    },
    showIntro() {
      console.log('show intro');
      this.activeYear = null;
      this.activeStory = this.stories.find((s) => s.isIntroStory);
      this.setLink();
    },
    toggleSearch() {
      this.showSearch = !this.showSearch;
      this.activeArt = null;
      this.activeTag = null;
      this.setLink();
    },
    toggleActiveYear(year) {
      if (this.activeYear == year) {
        this.clearFilters();
        this.$router.push('/');
      } else {
        this.$router.push(`/year/${year}`);
        this.activeYear = year; 
      }
      this.activeArt = null;
      this.activeStory = null;
    },
    updateYears(items) {
      const tempYears = {};
      items.forEach((item) => {
        const year = new Date(item.date).getFullYear();
        tempYears[year] = year;
      });
      this.years = this.years.concat(Object.keys(tempYears))
        .filter((year, index, self) => self.indexOf(year) === index)
        .sort()
        .reverse();
    },
    viewAllImages() {
      this.clearFilters();
    },
  },
};
</script>